export default "__VITE_ASSET__CKuCOeWa__"